function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAbout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 3.47 3.47",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.32 2a1.53 1.53 0 0 0 0-.3 1.55 1.55 0 0 0 0-.31c0-.09.05-.17.07-.24A.72.72 0 0 0 3.2.27C2.85-.09 2.65 0 2.28.09L2 .16a1.53 1.53 0 0 0-.3 0 1.55 1.55 0 0 0-.31 0l-.2-.07a.72.72 0 0 0-.92.18.71.71 0 0 0-.18.92c0 .07 0 .15.07.24a1.55 1.55 0 0 0 0 .31 1.53 1.53 0 0 0 0 .3c0 .09 0 .17-.07.24a.71.71 0 0 0 .18.92.72.72 0 0 0 .92.19l.24-.07a1.55 1.55 0 0 0 .31 0 1.53 1.53 0 0 0 .3 0l.24.07a.72.72 0 0 0 .92-.19.73.73 0 0 0 .18-.92c0-.07-.05-.15-.07-.24ZM1.87 1V.41a1.34 1.34 0 0 1 1.2 1.19h-.61a.72.72 0 0 0-.59-.6ZM1.6.41V1a.72.72 0 0 0-.6.6H.41A1.32 1.32 0 0 1 1.6.41ZM.39.39C.67.1.84.15 1.14.24a1.62 1.62 0 0 0-.9.9C.15.84.1.67.39.39Zm0 2.69a.59.59 0 0 1-.15-.75 1.61 1.61 0 0 0 .9.89c-.3.09-.47.14-.75-.15ZM1.6 2.5v.57a1.34 1.34 0 0 1-1.19-1.2H1a.72.72 0 0 0 .59.59Zm-.44-.76a.58.58 0 1 1 .58.57.58.58 0 0 1-.58-.57Zm.71 1.33v-.61a.72.72 0 0 0 .59-.59h.61a1.35 1.35 0 0 1-.39.81 1.29 1.29 0 0 1-.81.39Zm1.22 0c-.28.29-.44.24-.74.15a1.85 1.85 0 0 0 .54-.35 1.85 1.85 0 0 0 .35-.54.58.58 0 0 1-.14.74Zm.14-1.94a1.61 1.61 0 0 0-.89-.9.59.59 0 0 1 .75.15c.28.28.23.45.14.75Z",
    style: {
      fill: "#707071"
    },
    "data-name": "Layer 1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAbout);
export default __webpack_public_path__ + "static/media/about.7e252fabb8bbe695f31e5d7dfd04cc6a.svg";
export { ForwardRef as ReactComponent };